import React from "react";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import FormField from "layouts/pages/account/components/FormField";

import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/profile";
import { showToast, TOAST_TYPE } from "utils/toast";

function BasicInfo(props) {
  const profile = useSelector((state) => state.profile);
  const [form, setForm] = React.useState(profile?.userInfo || {});
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form || Object.keys(form).length === 0) {
      showToast("Nothing to save — profile data has not loaded yet.", TOAST_TYPE.error);
      return;
    }
    dispatch(actions.saveUserProfile(form));
  };

  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">Basic Info</MDTypography>
      </MDBox>
      <MDBox component="form" pb={3} px={3}>
        <Grid container spacing={3}>
          {props.role !== props.actionTypes.PATIENT && (
            <>
              <Grid item xs={12} sm={6}>
                <FormField name="orgName" label="Org Name" value={profile?.userInfo?.firstName || ""} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormField label="Role" value={profile?.userInfo?.role || ""} />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormField
                  name="qualifications"
                  onChange={handleChange}
                  label="Qualifications"
                  value={profile?.userInfo?.qualifications || ""}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormField
                  name="email"
                  label="Email"
                  value={profile?.userInfo?.email || ""}
                  placeholder="example@gmail.com"
                  inputProps={{ type: "email" }}
                />
              </Grid>
            </>
          )}

          {props.role === props.actionTypes.PATIENT && (
            <>
              <Grid item xs={12} sm={4}>
                <FormField label="Username" value={profile?.userInfo?.email || ""} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormField name="firstName" onChange={handleChange} label="First Name" defaultValue={profile?.userInfo?.firstName || ""} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormField name="lastName" onChange={handleChange} label="Last Name" defaultValue={profile?.userInfo?.lastName || ""} />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      name="sex"
                      onChange={(e, value) => setForm({ ...form, gender: value })}
                      value={profile?.userInfo?.gender || ""}
                      options={(props.sexList || []).map((e) => e.name)}
                      renderInput={(params) => (
                        <FormField {...params} label="Sex" InputLabelProps={{ shrink: true }} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormField name="age" onChange={handleChange} defaultValue={profile?.userInfo?.age || ""} label="Age" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      name="religion"
                      onChange={(e, value) => setForm({ ...form, religion: value })}
                      value={profile?.userInfo?.religion || ""}
                      options={(props.religionList || []).map((e) => e.name)}
                      renderInput={(params) => (
                        <FormField {...params} label="Religion" InputLabelProps={{ shrink: true }} />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  name="diagnosis"
                  onChange={(e, value) => setForm({ ...form, diagnosis: value })}
                  value={profile?.userInfo?.diagnosis || ""}
                  options={(props.diagnosisList || []).map((e) => e.name)}
                  renderInput={(params) => (
                    <FormField {...params} label="Diagnosis List" InputLabelProps={{ shrink: true }} />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  name="stages"
                  onChange={(e, value) => setForm({ ...form, stages: value })}
                  value={profile?.userInfo?.stages || ""}
                  options={(props.stagesList || []).map((e) => e.name)}
                  renderInput={(params) => (
                    <FormField {...params} label="Stages List" InputLabelProps={{ shrink: true }} />
                  )}
                />
              </Grid>
            </>
          )}

          <MDBox ml="auto" mt={2}>
            <MDButton onClick={handleSubmit} variant="gradient" color="dark" size="small">
              Update Profile
            </MDButton>
          </MDBox>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default BasicInfo;
